import React, { useEffect, useState } from "react";
import {
  FaCoins,
  FaPaintRoller,
  FaHammer,
  FaTools,
  FaCheckCircle,
  FaClock,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import BCImg from "../images/buildcoin.png"; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox } from "@fortawesome/free-solid-svg-icons";
import {
  ArrowLeft,
} from "lucide-react";
import { useNotification } from '../../context/NotificationContext';
import Header1 from '../Component/Header1';


const RFQListPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingRfqs, setLoadingRfqs] = useState(false);
  const [allRfqs, setAllRfqs] = useState([]);
  const API_BASE = process.env.REACT_APP_FORE_BRICKBUCKET || "";
  const [activeTab, setActiveTab] = useState("live");
  const liveRfqs = allRfqs?.filter(r => !r.status?.toLowerCase().includes("cancelled")) || [];
  const closedRfqs = allRfqs?.filter(r => r.status?.toLowerCase().includes("cancelled")) || [];
   const { notifications, setNotifications } = useNotification();
   
  useEffect(() => {
    fetchLiveRfqs();
  }, []);

  useEffect(()=>{
      if(notifications && notifications.length > 0 ){     
       fetchLiveRfqs();
     }
    },[notifications]);
  
  const fetchLiveRfqs = async () => {
    try {
     setLoadingRfqs(true);
      // Get user info
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      const userId = userData?._id;
      const token = userData?.token || sessionStorage.getItem('token');
      if (!userId) return;
  
      // Fetch RFQs from backend
      const res = await fetch(`${API_BASE}customer/rfq/get-rfqs-by-customer?customerId=${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token || '',
        },
      });
  
      const data = await res.json();
     // console.log('Live RFQs fetched', data);
  
      // Check if backend returned an array
      if (data.success && Array.isArray(data.data)) {
        // Reverse array so latest RFQs show first
        //const reversedData = [...data.data].reverse();
        setAllRfqs(data.data);
      } else {
        // Handle case when no data or unexpected structure
        setAllRfqs([]);
        console.warn('fetchLiveRfqs: data.data is not an array', data.data);
      }
  
    } catch (err) {
      console.error('fetchLiveRfqs', err);
      setAllRfqs([]); // fallback
    } finally {
      setLoadingRfqs(false);
    }
  };

  if (loadingRfqs) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-opacity-70 backdrop-blur-sm z-50">
        <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-400 text-xs">Loading RFQs...</p>
      </div>
    );
  }

  return (
   <div className="min-h-screen bg-gray-100">
  <Header1 title="My RFQs" showSearch={false}/>


  {/* RFQs Section */}
  <div className="rounded-md mt-3 bg-transparent mb-2">

    {/* 🔹 Sticky Tabs (Live / Closed) */}
  <div className="sticky top-0 z-20 bg-gray-100 px-6 border-b border-gray-200 flex justify-between items-center">
  {["live", "closed"].map((tab) => (
    <button
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`relative flex-1 text-center text-lg font-medium transition-all duration-200
        ${
          activeTab === tab
            ? "text-red-600"
            : "text-gray-700 hover:text-gray-900"
        }`}
    >
      {tab === "live" ? "Live" : "Closed"}

      {/* 🔴 Red underline for active tab */}
      {activeTab === tab && (
        <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-10 h-[3px] bg-red-500 rounded-full transition-all duration-300" />
      )}
    </button>
  ))}
</div>



    {/* 🔹 RFQs List Section (scrolls under sticky tabs) */}
    <div className="flex-1 overflow-y-auto pb-8 px-4 py-5 space-y-4">
  {(activeTab === "live" ? liveRfqs : closedRfqs)?.length > 0 ? (
    <div className="flex flex-col gap-3">
      {(activeTab === "live"
        ? liveRfqs.filter(rfq => !rfq.status?.toLowerCase().includes("cancelled"))
        : closedRfqs.filter(rfq => rfq.status?.toLowerCase().includes("cancelled"))
      ).map((rfq, idx) => {

    const images = rfq.items?.slice(0, 2) || [];
    const extra = rfq.items?.length > 2 ? rfq.items.length - 2 : 0;

    const getImageUrl = (imagePath) => {
      if (!imagePath) return null;
      const cleanPath = imagePath.startsWith("/")
        ? imagePath.substring(1)
        : imagePath;
      return `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${cleanPath}`;
    };

    const statusStyles = {
      waiting: "bg-yellow-50 text-yellow-700 border border-yellow-100",
      final: "bg-green-50 text-green-700 border border-green-100",
      order: "bg-blue-50 text-blue-700 border border-green-100",
      cancelled: "bg-gray-50 text-gray-700 border border-gray-100",
      default: "bg-gray-50 text-gray-600 border border-gray-100",
    };

    const getStatusStyle = (status) => {
      if (!status) return statusStyles.waiting;
      const s = status.toLowerCase();
      if (s.includes("waiting")) return statusStyles.waiting;
      if (s.includes("final")) return statusStyles.final;
      if (s.includes("order")) return statusStyles.order;
      if (s.includes("cancelled")) return statusStyles.cancelled;
      return statusStyles.default;
    };

    const style = getStatusStyle(rfq.status);
    const status = rfq.status?.toLowerCase() || "";

    const savingsBuildCoins =
      rfq.savings_breakup?.find((s) => s.type === "buildcoins")?.amount || 0;

    let buildCoinsToShow = 0;
    let messageLeft = "";
    let messageRight = "";

    if (status.includes("waiting")) {
      buildCoinsToShow = rfq.earned_build_coins || 0;
      messageLeft = buildCoinsToShow > 0 ? `Earn upto ${buildCoinsToShow}` : " ";
      messageRight = rfq.total_savings > 0 ? `Savings ₹${rfq.total_savings?.toLocaleString("en-IN") || 0}` : " ";
    } else if (status.includes("order") || status.includes("final")) {
      buildCoinsToShow = rfq.earned_build_coins;
      messageLeft = buildCoinsToShow > 0 ? `Earned ${buildCoinsToShow}` : " ";
      messageRight = rfq.total_savings > 0 ? `Saved ₹${rfq.total_savings?.toLocaleString("en-IN") || 0}` : " ";
    }



    const handleCardClick = () => {
      if (rfq?.quotation_id) {
        navigate("/consumer/app/rfqdetails", {
          state: { 
        rfq_id: rfq._id, 
        quotationId: rfq.quotation_id,
        from: 'rfqlist' 
      },
        });
      }
    };

    return (
      <div
        key={`rfq-${rfq._id || idx}`}
        onClick={handleCardClick}
        className="bg-white rounded-2xl border border-gray-200 shadow-sm p-3 flex flex-col justify-between flex-shrink-0 cursor-pointer hover:shadow-md hover:-translate-y-[2px] transition-all duration-150"
      >
        {/* 🔹 Top Row */}
        <div className="flex justify-between items-start mb-2">
          <p className="text-[13px] font-semibold text-gray-900">
            {rfq.rfq_number || "RFQ"}
          </p>
          <div className="text-right">
            <p className="text-[14px] font-bold text-gray-900">
              ₹{rfq.total?.toLocaleString("en-IN") || 0}
            </p>
            <p className="text-[11px] text-gray-500 leading-tight">
              {status.includes("order") || status.includes("final")
                ? "Final Price"
                : "Estimated Value"}
            </p>
          </div>
        </div>

        {/* 🔹 Middle Row: Images + Category */}
        <div className="flex items-center mt-1 mb-1">
          {images.length > 0 ? (
            <>
              {images.map((img, i) => (
                <div
                  key={i}
                  className="w-7 h-7 rounded-full overflow-hidden border-2 border-white"
                  style={{ marginLeft: i === 0 ? 0 : -8 }}
                >
                  <img
                    src={getImageUrl(img.image)}
                    alt={img.id || `Item ${i + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
              {extra > 0 && (
                <div
                  className="w-7 h-7 rounded-full bg-gray-200 text-gray-600 text-[10px] flex items-center justify-center border-2 border-white"
                  style={{ marginLeft: -8 }}
                >
                  +{extra}
                </div>
              )}
            </>
          ) : (
            <div className="text-[10px] text-gray-400">No Image</div>
          )}

          <span className="ml-2 text-[12px] font-medium text-gray-700 truncate">
            {rfq.product_categories?.length > 1
              ? `${rfq.product_categories[0]?.product_category_name || "Items"} & more`
              : rfq.product_categories?.[0]?.product_category_name || "General"}
          </span>
        </div>

        {/* 🔹 Status Section */}
        <div className={`rounded-lg ${style} px-2 py-1.5`}>
          <p className="text-[12px] font-semibold truncate">{rfq.status}</p>
          {rfq.status_message && (
            <p className="text-[10px] truncate opacity-80">
              {rfq.status_message}
            </p>
          )}
        </div>

        {/* 🔹 Bottom Row: Coins + Savings */}
        <div className="flex justify-between items-center text-[11px] text-gray-700 mt-2 border-t border-gray-100 pt-1.5">
          <span className="flex items-center">
            <span className="font-medium text-gray-500">{messageLeft}</span>
            {buildCoinsToShow > 0 && (
              <img
                src={BCImg}
                alt="BuildCoin"
                className="w-4 h-4 object-contain opacity-80 ml-1"
              />
            )}
          </span>
          <span className="text-green-700 font-medium">{messageRight}</span>
        </div>
      </div>
    );
  })}
</div>

      ) : (
        <div className="flex flex-col items-center justify-center py-8 bg-white rounded-lg shadow-sm">
          <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-2">
            <FontAwesomeIcon icon={faBox} className="text-gray-400 text-md" />
          </div>
          <p className="text-gray-700 text-sm font-medium">No RFQs found</p>
          <p className="text-gray-500 text-xs mt-1 max-w-[80%] leading-relaxed text-center">
            You haven’t placed any RFQs yet.
          </p>
        </div>
      )}
    </div>

  </div>
</div>

  );
};

export default RFQListPage;
